import _ from 'lodash';
import env from 'env';
import * as enums from './enums';

export function bytesToSize(bytes) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
}

//Drive manufacturers consider 1000GB as 1TB
export function bytesToSizeBase1000(bytes) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
  return `${(bytes / Math.pow(1000, i)).toFixed(0)} ${sizes[i]}`;
}

export function sortServiceAreaByDays(deliveryOptions) {
  return _.sortBy(deliveryOptions || [], (deliveryOption) => {
    const unit = deliveryOption.maxTime
      ? deliveryOption.maxTime.unit
      : deliveryOption.unit;
    const maxValue = deliveryOption.maxTime
      ? deliveryOption.maxTime.value
      : deliveryOption.max;
    return unit === enums.DeliveryOptionUnit.DAYS ? maxValue * 24 : maxValue;
  });
}

export function sortTheatreDeliveryOptions(deliveryOptions) {
  return _.sortBy(deliveryOptions || [], (deliveryOption) => {
    const unit = deliveryOption.deliveryTime
      ? deliveryOption.deliveryTime.unit
      : deliveryOption.unit;
    const maxValue = deliveryOption.deliveryTime
      ? deliveryOption.deliveryTime.value
      : deliveryOption.time;
    return unit === enums.DeliveryOptionUnit.DAYS ? maxValue * 24 : maxValue;
  });
}

export function isMaintenanceModeEnabled() {
  return env.maintenanceMode === true;
}
export function updateWorkOrderWithMovieData(workOrder, movieData) {
  const movieCompositions = [];
  const otherCompositions = [];
  workOrder.compositions.forEach((composition) => {
    const matchingMovieData = movieData.find((movie) =>
      movie.compositionId.includes(composition.composition),
    );
    if (matchingMovieData) {
      const { name, globalReleaseDate, language, id } = matchingMovieData;
      Object.assign(composition, {
        releaseDate: globalReleaseDate,
        movieName: name,
        language,
        movieId: id,
      });
      movieCompositions.push(composition);
    } else {
      otherCompositions.push(composition);
    }
  });

  const getCplTypePriority = (type) => {
    const normalizedType = (type || '').toLowerCase();
    switch (normalizedType) {
      case 'feature':
      case 'features':
        return 0;
      case 'trailer':
        return 1;
      case 'teaser':
        return 2;
      case 'advertisement':
        return 3;
      default:
        return 4;
    }
  };

  const sortByCplTypeAndName = (compositions) =>
    compositions.slice().sort((current, next) => {
      const currentPriority = getCplTypePriority(current.cplContentKind);
      const nextPriority = getCplTypePriority(next.cplContentKind);

      if (currentPriority !== nextPriority) {
        return currentPriority - nextPriority;
      }

      const currentName = (current.cplName || '').toLowerCase();
      const nextName = (next.cplName || '').toLowerCase();

      return currentName.localeCompare(nextName);
    });

  const movieGroups = _.groupBy(movieCompositions, (composition) =>
    (composition.movieName || '').toLowerCase(),
  );

  //show feature movies first, then sort by name
  const getMoviePriority = (compositions) =>
    Math.min(...compositions.map((c) => getCplTypePriority(c.cplContentKind)));

  const sortedMovieNames = Object.keys(movieGroups).sort((a, b) => {
    const aPriority = getMoviePriority(movieGroups[a]);
    const bPriority = getMoviePriority(movieGroups[b]);

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    return a.localeCompare(b);
  });

  const sortedMovieCompositions = sortedMovieNames.flatMap((movieName) =>
    sortByCplTypeAndName(movieGroups[movieName]),
  );

  const sortedOtherCompositions = sortByCplTypeAndName(otherCompositions);

  workOrder.compositions = [
    ...sortedMovieCompositions,
    ...sortedOtherCompositions,
  ];

  return workOrder;
}
